// extracted by mini-css-extract-plugin
export default {"button":"kwWbzMB1OZ8duG8MKduf","icon":"YFvSwXbPIzfzr5B1jC9k"};